import { createTheme } from "@mui/material";
import { deepmerge } from "../../utils/index.js";
import { createTidalThemeOptions } from "./createTidalThemeOptions.js";
function createTidalTheme(customThemeOptions = {}, colorMode = "light") {
  const themeOptions = deepmerge(createTidalThemeOptions(colorMode), customThemeOptions, {
    clone: true
  });
  if (themeOptions.vars) delete themeOptions.vars;
  const {
    colorSchemeSelector,
    rootSelector,
    disableCssColorScheme,
    cssVarPrefix = "tidal",
    shouldSkipGeneratingVar,
    ...otherThemeOptions
  } = themeOptions;
  const cssVariables = {
    colorSchemeSelector,
    cssVarPrefix,
    disableCssColorScheme,
    rootSelector,
    shouldSkipGeneratingVar
  };
  return createTheme({ ...otherThemeOptions, cssVariables });
}
export {
  createTidalTheme
};
//# sourceMappingURL=createTidalTheme.js.map
